import { useQuery } from '@apollo/client';

import { PaymentCardType } from '__generated__/GQL';

import { GetPhysicalCardInitialLimitsDocument } from './getPhysicalCardInitialLimits.gql';

export const usePhysicalPaymentCardLimits = (cardType: PaymentCardType) => {
  const { data, ...hook } = useQuery(GetPhysicalCardInitialLimitsDocument, {
    variables: {
      paymentCardType: cardType,
    },
  });

  if (!data) {
    return {
      ...hook,
      limits: null,
    };
  }

  const physicalPaymentCardData = data.physicalCardInitialLimits;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { __typename, ...limits } = physicalPaymentCardData;

  return {
    ...hook,
    limits,
  };
};

export type PhysicalPaymentCardLimits = NonNullable<
  ReturnType<typeof usePhysicalPaymentCardLimits>['limits']
>;

export { GetPhysicalCardInitialLimitsDocument };
